import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../components/ui/dialog';
import { Switch } from '../components/ui/switch';
import { Plus, Edit, Trash2, Images } from 'lucide-react';
import { toast } from 'sonner';
import MultiImageUploader from '../components/MultiImageUploader';

const empty = { title:'', title_en:'', description:'', description_en:'', price:0, duration:'', duration_en:'', image:'', gallery: [], category:'general', featured:false };

const AdminExcursions = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);

  const load = () => api.get('/excursions').then(r => setItems(r.data)).catch(()=>{});
  useEffect(() => { load(); }, []);

  const openNew = () => { setEditing(null); setForm(empty); setOpen(true); };
  const openEdit = (it) => {
    const gallery = Array.isArray(it.gallery) && it.gallery.length ? it.gallery : (it.image ? [it.image] : []);
    setEditing(it);
    setForm({ ...it, gallery });
    setOpen(true);
  };

  const save = async () => {
    try {
      const gallery = Array.isArray(form.gallery) ? form.gallery : [];
      const payload = {
        ...form,
        gallery,
        image: gallery[0] || form.image || '',
        price: parseFloat(form.price),
      };
      if (editing) await api.put(`/excursions/${editing.id}`, payload);
      else await api.post('/excursions', payload);
      toast.success('Guardado');
      setOpen(false);
      load();
    } catch { toast.error('Error al guardar'); }
  };

  const remove = async (id) => {
    if (!window.confirm('¿Eliminar esta excursión?')) return;
    try { await api.delete(`/excursions/${id}`); toast.success('Eliminado'); load(); } catch { toast.error('Error'); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-black text-white">Excursiones</h1>
          <p className="text-white/60">Gestiona excursiones y tours</p>
        </div>
        <Button onClick={openNew} className="btn-orange border-0 gap-2"><Plus className="w-4 h-4" /> Nueva</Button>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map(it => (
          <div key={it.id} className="glass-card rounded-xl overflow-hidden">
            <img src={it.image} alt={it.title} className="w-full h-40 object-cover" />
            <div className="p-5">
              <div className="flex justify-between items-start gap-2 mb-2">
                <h3 className="font-bold text-white">{it.title}</h3>
                <span className="text-[#ff6b1a] font-bold">${it.price}</span>
              </div>
              <p className="text-white/60 text-xs mb-3 line-clamp-2">{it.description}</p>
              <div className="flex items-center justify-between text-xs text-white/40 mb-3">
                <span>{it.duration}</span>
                {it.featured && <span className="text-[#ff6b1a]">★ Destacada</span>}
              </div>
              <div className="flex gap-2">
                <Button onClick={() => openEdit(it)} variant="outline" size="sm" className="flex-1 border-white/15 text-white hover:bg-white/5"><Edit className="w-3.5 h-3.5 mr-1" /> Editar</Button>
                <Button onClick={() => remove(it.id)} variant="outline" size="sm" className="border-red-500/30 text-red-400 hover:bg-red-500/10"><Trash2 className="w-3.5 h-3.5" /></Button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#0f0f0f] border-white/10 text-white max-w-2xl">
          <DialogHeader><DialogTitle>{editing ? 'Editar' : 'Nueva'} Excursión</DialogTitle></DialogHeader>
          <div className="grid md:grid-cols-2 gap-4 max-h-[70vh] overflow-y-auto">
            <div><Label>Título (ES)</Label><Input value={form.title} onChange={(e)=>setForm({...form,title:e.target.value})} className="bg-black/40 border-white/10" /></div>
            <div><Label>Título (EN)</Label><Input value={form.title_en} onChange={(e)=>setForm({...form,title_en:e.target.value})} className="bg-black/40 border-white/10" /></div>
            <div className="md:col-span-2"><Label>Descripción (ES)</Label><Textarea value={form.description} onChange={(e)=>setForm({...form,description:e.target.value})} rows={3} className="bg-black/40 border-white/10" /></div>
            <div className="md:col-span-2"><Label>Descripción (EN)</Label><Textarea value={form.description_en} onChange={(e)=>setForm({...form,description_en:e.target.value})} rows={3} className="bg-black/40 border-white/10" /></div>
            <div><Label>Precio (USD)</Label><Input type="number" value={form.price} onChange={(e)=>setForm({...form,price:e.target.value})} className="bg-black/40 border-white/10" /></div>
            <div><Label>Duración (ES)</Label><Input value={form.duration} onChange={(e)=>setForm({...form,duration:e.target.value})} className="bg-black/40 border-white/10" /></div>
            <div><Label>Duración (EN)</Label><Input value={form.duration_en} onChange={(e)=>setForm({...form,duration_en:e.target.value})} className="bg-black/40 border-white/10" /></div>
            <div><Label>Categoría</Label><Input value={form.category} onChange={(e)=>setForm({...form,category:e.target.value})} className="bg-black/40 border-white/10" /></div>
            <div className="md:col-span-2"><Label>Imágenes (la primera es la principal)</Label>
              <MultiImageUploader value={form.gallery} onChange={(urls) => setForm({...form, gallery: urls, image: urls[0] || ''})} folder="tts/excursions" />
            </div>
            <div className="md:col-span-2 flex items-center gap-3"><Switch checked={form.featured} onCheckedChange={(v)=>setForm({...form,featured:v})} /> <Label>Destacada en homepage</Label></div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={()=>setOpen(false)} className="border-white/15 text-white">Cancelar</Button>
            <Button onClick={save} className="btn-orange border-0">Guardar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AdminExcursions;
